import { Box } from "@mui/material"
import { useGetOne } from "react-admin"

interface IProps {
  fileId: string
}

const ImageField = ({fileId}: IProps) => {
  const { data: file, isLoading } = useGetOne('files', {id: fileId})
  if(isLoading) return <>Loading...</>
  const fileAsBase64WithHeader = `${file?.mimeType},${file?.fileContentAsBase64}`

  return (
    <Box
      component={'img'}
      sx={{maxWidth: 200}}
      src={fileAsBase64WithHeader}
    />
  )
}

export default ImageField